import type PropertyListSection from '~/components/PropertyList/PropertyListSection.vue';
import type { Ref } from 'vue';

export type MenuFixedLevels = { 1: number; 2: number };

export enum DragState {
	IDLE = 'idle',
	DRAGGING = 'dragging',
	SCROLLING = 'scrolling',
	MOMENTUM_SCROLLING = 'momentum-scrolling',
	TRANSITIONING = 'transitioning'
}

export enum MenuLevel {
	CLOSED = 0,
	HALF_OPEN = 1,
	FULLY_OPEN = 2
}

export interface DragControllerState {
	currentState: DragState;
	menuLevel: MenuLevel;
	currentY: number;
	lastY: number;
	isScreenBelowBreakpoint: boolean;
	isDragging: boolean;
	isInScrollMode: boolean;
	headerControlledByScroll: boolean;
}

export interface DragControllerConfig {
	breakpoint?: number;
	menuFixedLevels: Ref<MenuFixedLevels>;
	dragLimit?: number;
	scrollContainer?: Ref<InstanceType<typeof PropertyListSection> | null>;
	disabled?: Ref<boolean>;
}

export interface ScrollMomentumState {
	velocity: number;
	isActive: boolean;
	lastTime: number;
	lastPosition: number;
	lastRawMovement: number;
	velocityHistory: Array<{ velocity: number; time: number }>;
}

export interface DragPositionState {
	yOnDrag: number;
	initialMouseY: number;
	currentMovement: number;
	actualMovement: number;
}

export interface ScreenThresholds {
	readonly FULLY_OPEN: number;
	readonly HALF_OPEN: number;
}

export interface MapZoomConstraints {
	readonly DEFAULT: number;
	readonly MIN_AFTER_BOUNDS: number;
	readonly FIT_BOUNDS_PADDING: number;
}

export interface DragMovementParams {
	movement: [number, number];
	dragging: boolean;
	initial: [number, number];
}

export interface UseDragToBottomReturn {
	dragRef: Ref<HTMLElement | null>;
	shouldFixOnBottom: Ref<boolean>;
	isDragging: Ref<boolean>;
	menuBottomLevel: Ref<number>;
	currentY: Ref<number>;
	dragHandler: (event: DragMovementParams) => void;
	moveBackOneLevel: () => Promise<void>;
	moveBackToInitialPosition: () => Promise<void>;
	toggleToClosedWhenOpen: () => Promise<void>;
	toggleToHalfOpenWhenClosed: () => Promise<void>;
	setMenuPosition: (level: number, movement: number) => void;
	MENU_LEVELS: typeof MenuLevel;
	isTransitioning: Ref<boolean>;
}
